import {connect} from "react-redux";
import Header from "./Header";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {logoutUser} from "../../globalState/user/actions";
import {toggleLeftMenu} from "../../globalState/app/actions";
import {getBaseUrlSelector, getPublicLink, getUserRoleSelector} from "../../globalState/app/selectros";



let mapStateToProps = (state, props) => {
    return {
        leftMenuActive: state.app.leftMenuActive,
        userRole: getUserRoleSelector(state),
        baseUrl: getBaseUrlSelector(state),
        publicLink: getPublicLink(state),
    }
};


export default compose(connect(mapStateToProps, {toggleLeftMenu, logoutUser}), withRouter)(Header);



